import React from 'react';
import { ListGroup, Container, Row, Col } from 'react-bootstrap';
import PetAndOwnerModel from '../util/Models';

function SearchHits(props) {

    function hitClicked(row) {
        props.onRowSelected(
            new PetAndOwnerModel(row.OwnerId, `${row.Givenname} ${row.Surname}`, row.PetId, row.Name)
        );
    }

    function getHits() {
        const hits = props.rows.map((r) => (
            <ListGroup.Item key={r.PetId} action onClick={f => hitClicked(r)}>
                <Container>
                    <Row>
                        <Col>{r.Givenname} {r.Surname}</Col>
                        <Col>{r.Name}</Col>
                    </Row>
                </Container>
            </ListGroup.Item>
        ));
        return hits;
    }

    if (props.rows !== null) {
        return (
            <ListGroup style={{marginTop: '10px'}}>
                <ListGroup.Item variant="info">
                    <Container>
                        <Row>
                            <Col>Ägare</Col>
                            <Col>Djur</Col>
                        </Row>
                    </Container>
                </ListGroup.Item>
                {getHits()}
            </ListGroup>
        );
    }
    else {
        return <div></div>;
    }

}

export default SearchHits;